;(function(){
	
	main();
	
	function main() {
		// document.body.addEventListener('pageshow', onPageShow);
		onPageShow();
	}
	
	/**
	 * ページ表示
	 */
	function onPageShow() {
		/*
		// ファーストビューロック
		new ScrollLock();
		
		// ローディング
		new Loading();
		
		// オープニング
		// テキスト分割
		document.querySelectorAll('[data-j-split="target"]').forEach(( dom )=>{
			new SplitText( dom );
		});
		document.querySelectorAll('[data-j-split-guide="target"]').forEach(( dom )=>{
			new SplitGuideText( dom );
		});
		// 動的テキストサイズ
		document.querySelectorAll('[data-j-dynamic-fontsize="target"]').forEach(( dom )=>{
			new DynamicFontSize( dom );
		});
		// オープニング本体
		document.querySelectorAll('[data-j-op="target"]').forEach(( dom )=>{
			new Opening( dom );
		});
		// 背景動画
		document.querySelectorAll('.p-home-bg').forEach(( dom )=>{
			new HomeBg( dom );
		});
		
		// スクロールコンテンツ
		document.querySelectorAll('[data-j-scroll-content="container"]').forEach(( dom )=>{
			new ScrollContents( dom );
		});
		*/
		
		// おすすめ商品
		document.querySelectorAll('.j-home-pickup-slide').forEach(function(dom){
			new PickupSlider( dom );
		});
		
		/*
		// スキップ
		document.querySelectorAll('[data-j-skip-feature="switch"]').forEach(( dom )=>{
			new SkipFeature( dom );
		});
		*/
	}
	
	/**
	 * ファーストビューロック
	 */
	function ScrollLock() {
		let $html = document.documentElement;
		let $body = document.body;
		
		_init();
		
		function _init() {
			window.scrollTo(0,0);
			$body.scrollTo(0,0);
			$body.classList.add('is-scroll-lock');
			$body.addEventListener('opComplete', _onOpComplete);
		}
		
		function _onOpComplete() {
			$body.classList.remove('is-scroll-lock');
		}
	}
	
	/**
	 * ローディング
	 */
	function Loading() {
		let $html = document.documentElement;
		let $body = document.body;
		let $loading = document.querySelector('[data-j-loading="target"]');
		let $video = document.querySelector('[data-j-loading="video"]');
		let timer;
		
		_init();
		
		function _init() {
			$video.addEventListener('playing', _onLoad);
			timer = setTimeout(()=>{
				_onLoad();
			}, 15000);
		}
		
		function _onLoad() {
			console.log('Loading: _onLoad');
			clearTimeout( timer );
			$video.removeEventListener('playing', _onLoad);
			
			setTimeout(_showLogo, 1000);
		}
		
		function _showLogo() {
			$loading.classList.add('is-logo-visible');
			setTimeout(_hide, 2500);
		}
		
		function _hide() {
			console.log('Loading: _hide');
			$html.classList.add('is-home-waiting');
			window.scrollTo(0,0);
			$body.scrollTo(0,0);
			$loading.classList.add('is-hidden');
			setTimeout(_complete, 1000);
		}
		
		function _complete() {
			$html.classList.remove('is-home-waiting');
			$body.dispatchEvent(new Event('loadingComplete'));
		}
	}
	
	/**
	 * テキスト分割
	 */
	function SplitText( dom ) {
		let $target = dom;
		let original = $target.innerHTML;
		let lines = original.split('<br>');
		
		lines.forEach(( line, idx )=>{
			let newLine = '';
			line = line.trim();
			
			line.split('').forEach((char)=>{
				if ( char == ' ' ) {
					newLine += '<span>&nbsp;</span>';
				}
				else if ( ['。', '、', 'ー'].indexOf( char ) >= 0 ) {
					newLine += '<span><span class="ios-mark">' + char + '</span></span>';
				}
				else {
					newLine += '<span>' + char + '</span>';
				}
			});
			lines[idx] = newLine;
		});
		
		$target.innerHTML = lines.join('<br>');
	}
	
	/**
	 * テキスト分割(シャドウあり)
	 */
	function SplitGuideText( dom ) {
		let $target = dom;
		let $shadow = document.createElement('span');
		let $base = document.createElement('span');
		let original = $target.innerHTML;
		let lines = original.split('<br>');
		
		lines.forEach(( line, idx )=>{
			// lines[idx] = '<span>' + line.trim() + '</span>';
			lines[idx] = '<span>' + line + '</span>';
		});
		
		$shadow.classList.add('guide-shadow');
		$shadow.innerHTML = lines.join('<br>');
		$base.classList.add('guide-base');
		$base.innerHTML = lines.join('<br>');
		
		$target.innerHTML = '';
		$target.appendChild( $shadow );
		$target.appendChild( $base );
	}
	
	/**
	 * 動的テキストサイズ
	 */
	function DynamicFontSize( dom ) {
		let $target = dom;
		let baseWidth = parseFloat( $target.getAttribute('data-j-dynamic-fontsize-width') );
		let baseHeight = parseFloat( $target.getAttribute('data-j-dynamic-fontsize-height') );
		let baseSpWidth = parseFloat( $target.getAttribute('data-j-dynamic-fontsize-sp-width') );
		let baseSpHeight = parseFloat( $target.getAttribute('data-j-dynamic-fontsize-sp-height') );
		_init();
		
		function _init() {
			_resize();
			
			window.addEventListener('resize', _onResize);
			window.addEventListener('orientationchange', _onResize);
		}
		
		function _onResize() {
			if ( typeof window.ontouchstart === 'undfined' ) {
				_resize();
			}
		}
		
		function _resize() {
			let mediaQuery = window.matchMedia('(min-width: 990px)');
			let targetWidth = $target.offsetWidth;
			let targetHeight = $target.offsetHeight;
			let resizeWidth = ( mediaQuery.matches ) ? baseWidth : baseSpWidth;
			let resizeHeight = ( mediaQuery.matches ) ? baseHeight : baseSpHeight;
			let scale = targetWidth / resizeWidth;
			
			if ( targetHeight < resizeHeight * scale ) {
				scale = targetHeight / resizeHeight;
			}
			
			$target.style.fontSize = ( scale * 10 ) + 'px';
		}
	}
	
	/**
	 * オープニング
	 */
	function Opening( dom ) {
		let $body = document.body;
		let $op = dom;
		
		_init();
		
		function _init() {
			$body.addEventListener('loadingComplete', _onLoadingComplete);
		}
		
		function _onLoadingComplete() {
			console.log( 'OP loadingComplete' );
			$op.classList.add('is-visible');
			
			setTimeout( _complete, 3000 );
		}
		
		function _complete() {
			$body.dispatchEvent( new Event('opComplete') );
		}
	}
	
	/**
	 * 背景動画
	 */
	function HomeBg( dom ) {
		let $body = document.body;
		let $base = dom;
		let $video = $base.querySelector('video');
		
		_init();
		
		function _init() {
			if ( ! $video ) {
				return;
			}
			$body.addEventListener('opComplete', _onOpComplete);
		}
		
		function _onOpComplete() {
			$video.currentTime = 0;
		}
	}
	
	/**
	 * スクロールコンテンツ
	 */
	function ScrollContents( dom ) {
		let $container = dom;
		let $sections = $container.querySelectorAll('[data-j-scroll-content="section"]');
		
		_init();
		
		function _init() {
			$sections.forEach(( dom )=>{
				let $section = dom;
				$section.style.position = 'fixed';
				$section.style.left = 0;
				$section.style.top = 0;
			});
			
			_resize();
			_update();
			window.addEventListener('resize', _onResize);
		}
		
		function _onResize() {
			if ( typeof window.ontouchstart === 'undfined' ) {
				_resize();
			}
		}
		
		function _resize() {
			let baseHeight = window.innerHeight
			let height = baseHeight;
			
			$sections.forEach(( dom )=>{
				let $section = dom;
				let range = parseFloat( $section.getAttribute('data-j-scroll-range') );
				height += baseHeight * range;
			});
			
			$container.style.height = height + 'px';
		}
		
		function _update() {
			let top = $container.offsetTop;
			let baseHeight = window.innerHeight;
			let scroll = window.scrollY;
			let start = top;
			
			let $header = document.querySelector('#shopify-section-header');
			if ( $header ) {
				start -= $header.offsetHeight;
			}
			
			$sections.forEach(( dom )=>{
				let $section = dom;
				let range = parseFloat( $section.getAttribute('data-j-scroll-range') );
				let height = baseHeight * range;
				let over = scroll - start;
				let overPer = Math.floor( 100 * over / height );
				overPer = ( overPer >= 0 ) ? overPer : -1;
				overPer = ( overPer <= 100 ) ? overPer : 100;
				
				$section.setAttribute( 'data-j-scroll-content-pos', overPer );
				
				start += height;
			});
			
			window.requestAnimationFrame( _update );
		}
	}
	
	// おすすめ商品
	function PickupSlider(dom) {
		let TOUCH_BUFF = 10; // px
		let $base = dom;
		let $nav = $base.querySelector('.j-pickup-slide__nav');
		let $scroll = $base.querySelector('.j-pickup-slide__scroll');
		let $prev = $base.querySelector('.j-pickup-slide__prev');
		let $next = $base.querySelector('.j-pickup-slide__next');
		let conWidth;
		let current = 0;
		let max;
		let lock = false;
		let touching = false;
		let dragging = false;
		let scrolling = false;
		let touchStart = { x: 0, y: 0 };
		let touchMove = { x: 0, y: 0 };
		
		_init();
		
		function _init() {
			_splitColumn();
			_copyColumn();
			_resize();
			_resetPosition();
			_updateNav();
			
			window.addEventListener('resize', _onResize);
			$base.addEventListener('touchstart', _onTouchStart);
			$base.addEventListener('mousedown', _onTouchStart);
			$prev.addEventListener('click', _onClickPrev);
			$next.addEventListener('click', _onClickNext);
		}
		
		function _splitColumn() {
			let $items = $scroll.querySelectorAll('.j-pickup-slide__item');
			let $column;
			let $navLink;
			let column = -1;
			
			$items.forEach(( $item, i )=>{
				if ( i % 3 == 0 ) {
					column ++;
					$column = document.createElement('div');
					$column.classList.add('p-home-pickup__column');
					$column.classList.add('j-pickup-slide__column');
					$column.setAttribute('id', 'col' + column);
					$scroll.append( $column );
					
					$navLink = document.createElement('span');
					$navLink.setAttribute( 'data-j-pickup-slide', column );
					$navLink.addEventListener( 'click', _onClickNav );
					$nav.append( $navLink );
				}
				$column.append( $item );
			});
			
			max = $scroll.querySelectorAll('.j-pickup-slide__column').length - 1;
		}
		
		function _copyColumn() {
			let $columns = $scroll.querySelectorAll('.j-pickup-slide__column');
			let last = $columns.length - 1;
			
			$columns.forEach(( $column )=>{
				$scroll.append( $column.cloneNode(true) );
			});
			$columns.forEach(( $column, i )=>{
				$scroll.prepend( $columns.item(last - i).cloneNode(true) );
			});
		}
		
		function _resize() {
			conWidth = $base.offsetWidth;
		}
		
		function _resetPosition() {
			let $columns = $scroll.querySelectorAll('.j-pickup-slide__column');
			let colWidth = $columns.item(0).offsetWidth;
			let left = conWidth * 0.5 - ( colWidth * max + colWidth * 1.5 );
			
			$scroll.style.left = left + 'px';
		}
		
		function _movePrev() {
			current = ( current > 0 ) ? current - 1 : max;
			
			_slide(1);
			_updateNav();
		}
		
		function _moveNext() {
			current = ( current < max ) ? current + 1 : 0;
			
			_slide(-1);
			_updateNav();
		}
		
		function _moveTo( next ) {
			let move = current - next;
			current = next;
			
			if ( move != 0 ) {
				_slide( move );
			}
			_updateNav();
		}
		
		function _updateNav() {
			let $navLinks = $nav.childNodes;
			
			$navLinks.forEach(( $navLink, i )=>{
				if ( i == current ) {
					$navLink.classList.add('is-active');
				}
				else {
					$navLink.classList.remove('is-active');
				}
			});
		}
		
		function _onResize() {
			let prevWidth = conWidth;
			
			_resize();
			
			if ( prevWidth != conWidth ) {
				_resetPosition();
			}
		}
		
		function _onTouchStart( evt ) {
			if ( touching || lock ) {
				return;
			}
			touching = true;
			dragging = false;
			scrolling = false;
			
			touchStart = {
				x: ( typeof evt['touches'] != 'undefined' ) ? evt['touches'][0].clientX : evt.clientX,
				y: ( typeof evt['touches'] != 'undefined' ) ? evt['touches'][0].clientY : evt.clientY
			};
			touchMove = { x: 0, y: 0 };
			
			document.addEventListener('touchmove', _onTouchMove, { passive: false });
			document.addEventListener('touchend', _onTouchEnd);
			document.addEventListener('mousemove', _onTouchMove, { passive: false });
			document.addEventListener('mouseup', _onTouchEnd);
		}
		
		function _onTouchMove( evt ) {
			let touchTemp = {
				x: ( typeof evt['touches'] != 'undefined' ) ? evt['touches'][0].clientX : evt.clientX,
				y: ( typeof evt['touches'] != 'undefined' ) ? evt['touches'][0].clientY : evt.clientY
			};
			touchMove = {
				x: touchTemp.x - touchStart.x,
				y: touchTemp.y - touchTemp.y
			};
			
			if ( ! dragging && ! scrolling ) {
				if ( Math.abs( touchMove.x ) > Math.abs( touchMove.y ) && Math.abs( touchMove.x ) > TOUCH_BUFF ) {
					dragging = true;
				}
				else if ( Math.abs( touchMove.x ) < Math.abs( touchMove.y ) && Math.abs( touchMove.y ) > TOUCH_BUFF ) {
					scrolling = true;
				}
			}
			if ( dragging && evt.cancelable ) {
				evt.preventDefault();
				evt.stopPropagation();
			}
		}
		
		function _onTouchEnd() {
			document.removeEventListener('touchmove', _onTouchMove, { passive: false });
			document.removeEventListener('touchend', _onTouchEnd);
			document.removeEventListener('mousemove', _onTouchMove, { passive: false });
			document.removeEventListener('mouseup', _onTouchEnd);
			
			if ( lock ) {
				return;
			}
			if ( dragging ) {
				if ( touchMove.x > 0 ) {
					_movePrev();
				}
				else {
					_moveNext();
				}
			}
			touching = false;
			dragging = false;
			scrolling = false;
		}
		
		function _onClickPrev() {
			if ( lock ) {
				return;
			}
			_movePrev();
		}
		
		function _onClickNext() {
			if ( lock ) {
				return;
			}
			_moveNext();
		}
		
		function _onClickNav( evt ) {
			if ( lock ) {
				return;
			}
			let $link = evt.currentTarget;
			let next = $link.getAttribute('data-j-pickup-slide');
			
			_moveTo( next );
		}
		
		function _slide( move ) {
			lock = true;
			
			let $columns = $scroll.querySelectorAll('.j-pickup-slide__column');
			let colWidth = $columns.item(0).offsetWidth;
			let leftStart = parseFloat( $scroll.style.left );
			let leftEnd = leftStart + colWidth * move;
			let duration = 500; // msec
			let startTime = null;
			
			requestAnimationFrame(__anim);
			
			function __anim( currentTime ) {
				if ( startTime === null ) {
					startTime = currentTime;
				}
				let timeElapsed = currentTime - startTime;
				let run = __ease( timeElapsed, leftStart, leftEnd - leftStart, duration );
				$scroll.style.left = run + 'px';
				
				if ( timeElapsed < duration ) {
					requestAnimationFrame( __anim );
				}
				else {
					_animEnd();
				}
			}
			
			function _animEnd() {
				$scroll.style.left = leftEnd + 'px';
				
				if ( move > 0 ) {
					for ( let i = 0; i < move; i ++ ) {
						$scroll.prepend( $scroll.querySelectorAll('.j-pickup-slide__column').item(max + (max + 1) * 2) );
					}
				}
				else {
					for ( let i = 0; i < move * -1; i ++ ) {
						$scroll.append( $scroll.querySelectorAll('.j-pickup-slide__column').item(0) );
					}
				}
				_resetPosition();
				
				lock = false;
			}
			
			function __ease( t, b, c, d ) {
				t /= d / 2;
				if (t < 1) return c / 2 * t * t + b;
				t--;
				return -c / 2 * (t * (t - 2) - 1) + b;
			}
		}
	}
	
	// スキップ
	function SkipFeature( dom ) {
		let $btn = dom;
		let $target = document.querySelector('[data-j-skip-feature="target"]');
		let $header = document.querySelector('.j-header');
		
		_init();
		
		function _init() {
			$btn.addEventListener('click', _onClickBtn);
		}
		
		function _onClickBtn(evt) {
			evt.preventDefault();
			
			let rect = $target.getBoundingClientRect();
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			let offsetTop = rect.top + scrollTop;
			let headerHeight = $header.offsetHeight + $header.offsetTop;
			
			window.scrollTo( 0, offsetTop - headerHeight );
		}
	}
	
})();